export default __webpack_public_path__ + "static/underoutfit-c7048d76b409cb1bcedf1a46d9221939.png";